/**
 * Sync pack price/savings under ATC when variants change.
 * Mirrors the theme's section HTML swap pattern (product-info / sticky ATC).
 */
if (!customElements.get('fraire-pack-savings')) {
  customElements.define(
    'fraire-pack-savings',
    class FrairePackSavings extends HTMLElement {
      #unsubscribe;

      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.#unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event?.data) return;
          if (String(event.data.sectionId) !== String(this.dataset.section)) return;

          const next = event.data.html?.getElementById(this.id);
          if (!next) return;

          this.innerHTML = next.innerHTML;
          if (next.hasAttribute('hidden')) {
            this.setAttribute('hidden', '');
          } else {
            this.removeAttribute('hidden');
          }
        });
      }

      disconnectedCallback() {
        this.#unsubscribe?.();
      }
    }
  );
}
